import { createFileRoute } from '@tanstack/react-router'
import { Header } from '@/components/Header'
import { Footer } from '@/components/Footer'
import { LegalDocument } from '@/features/legal/components/LegalDocument'
import { DataProcessingContent } from '@/features/legal/components/DataProcessingContent'
import { DATA_PROCESSING_TOC } from '@/features/legal/data/dataProcessingToc'
import { PageHero } from '@/shared/components/marketing/PageHero'
import { generateLinks, generateMetaTags, routeSEO } from '@/lib/seo'

export const Route = createFileRoute('/data-processing')({
  head: () => ({
    meta: generateMetaTags(routeSEO['/data-processing']),
    links: generateLinks(routeSEO['/data-processing']),
  }),
  component: DataProcessingPage,
})

function DataProcessingPage() {
  return (
    <div className="relative flex min-h-screen flex-col overflow-x-clip bg-[var(--color-bg-primary)]">
      <Header />

      <main className="flex-1">
        <PageHero
          eyebrow="Legal"
          title="Data processing agreement"
          lede="Last updated: February 5, 2026"
        />
        <LegalDocument toc={DATA_PROCESSING_TOC}>
          <DataProcessingContent />
        </LegalDocument>
      </main>

      <Footer />
    </div>
  )
}
